import React from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';

export default function TestimonialsSection() {
    const testimonials = [
        {
            id: 1,
            name: 'Alex Thompson',
            text: 'Amazing learning experience! The instructors are top-notch and the course content is incredibly well-structured.',
            rating: 5,
            course: 'Computer Science',
            image: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=60&h=60&fit=crop&crop=face'
        },
        {
            id: 2,
            name: 'Maria Garcia',
            text: 'Best educational platform I\'ve ever used. The interactive lessons and practical projects really helped me grow.',
            rating: 5,
            course: 'Web Development',
            image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=60&h=60&fit=crop&crop=face'
        },
        {
            id: 3,
            name: 'John Smith',
            text: 'The course content is excellent and very well structured. I was able to land my dream job after completing the program.',
            rating: 5,
            course: 'Data Science',
            image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop&crop=face'
        }
    ];

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-6xl mx-auto px-6">
                {/* Modern Header */}
                <div className="text-center mb-16">
                    <div className="inline-block mb-6">
                        <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-2xl px-6 py-3 shadow-sm">
                            <FaQuoteLeft className="text-blue-600 text-lg" />
                            <span className="text-blue-700 font-semibold text-sm lemon-milk">STUDENT SUCCESS STORIES</span>
                        </div>
                    </div>

                    <h2 className="text-4xl font-black text-gray-900 mb-4 lemon-milk">
                        Student{' '}
                        <span className="text-blue-600">
                            Feedback
                        </span>
                    </h2>

                    <p className="text-lg text-gray-600 max-w-2xl mx-auto poppins">
                        Discover how our students achieved their academic goals and built confidence
                        in mathematics through our proven teaching methods.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-6">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={testimonial.id}
                            className="group bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                        >
                            <div className="flex items-center gap-1 mb-4">
                                {[...Array(testimonial.rating)].map((_, i) => (
                                    <FaStar key={i} className="text-yellow-500 text-sm" />
                                ))}
                            </div>

                            <div className="mb-6">
                                <FaQuoteLeft className="text-blue-600 text-lg mb-3 opacity-60" />
                                <p className="text-gray-700 text-sm leading-relaxed poppins">{testimonial.text}</p>
                            </div>

                            <div className="flex items-center gap-3">
                                <div className="relative">
                                    <div className="absolute inset-0 bg-blue-600/20 rounded-full blur-sm"></div>
                                    <img
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        className="relative w-12 h-12 rounded-full object-cover border-2 border-gray-200"
                                    />
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 text-sm lemon-milk">{testimonial.name}</h4>
                                    <p className="text-blue-600 font-medium text-xs poppins">{testimonial.course}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Call to Action */}
                <div className="mt-16 text-center">
                    <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                        <h3 className="text-2xl font-bold text-gray-900 mb-4 lemon-milk">Ready to Join Our Success Stories?</h3>
                        <p className="text-gray-600 mb-6 poppins">Start your mathematics journey today and become our next success story.</p>
                        <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors lemon-milk">
                            Enroll Now
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}
